import React from 'react';
import { CTABand } from '../../components/CTABand';
export function MiniTroopersFinalCTA() {
  return <CTABand headline="Ready for Your Child's First Class?" copy="Claim a free week of Mini Troopers and see how martial arts can help your preschooler thrive." data-id="element-2533" />;
}